import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { UiComponentsModule } from '@app/ui-components/ui-components.module';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { ProgressbarModule } from 'ngx-bootstrap/progressbar';
import { TranslateModule } from '@ngx-translate/core';
import { A11yModule } from '@angular/cdk/a11y';
import { CdkTableModule } from '@angular/cdk/table';
import { ModalmessageComponent } from './modals/modalmessage/modalmessage.component';
import {ModalextensionComponent} from '@app/shared/modals/modalextension/modalextension.component';
import {ModaldevComponent} from '@app/shared/modals/modaldev/modaldev.component';
import { ModalscreenshotComponent } from './modals/modalscreenshot/modalscreenshot.component';
import { ModaluntilComponent } from './modals/modaluntil/modaluntil.component';
import { ModalscreenshotsetupComponent } from './modals/modalscreenshotsetup/modalscreenshotsetup.component';
import { ModalroamingComponent } from './modals/modalroaming/modalroaming.component';
import { AppListComponent } from './components/app-list/app-list.component';
import { ModaltanComponent } from './modals/modaltan/modaltan.component';
import { AppListFilterComponent } from './components/app-list/app-list-filter/app-list-filter.component';
import { ModalgrouprenameComponent } from './modals/modalgrouprename/modalgrouprename.component';
import { ModaldevicenameComponent } from './modals/modaldevicename/modaldevicename.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { ModalselfprotectionComponent } from './modals/modalselfprotection/modalselfprotection.component';
import { ModalchangeloginnoticeComponent } from './modals/modalchangeloginnotice/modalchangeloginnotice.component';
import { ModalfilenameComponent } from './modals/modalfilename/modalfilename.component';
import { ModalAppDetailsSuggestionComponent } from './modals/modal-app-details-suggestion/modal-app-details-suggestion.component';
import {ActiondropdownComponent} from '@app/shared/components/actiondropdown/actiondropdown.component';
import {CardDeviceComponent} from '@app/shared/components/card-device/card-device.component';
import {CardPasswordComponent} from '@app/shared/components/card-password/card-password.component';
import {CardRoamingComponent} from '@app/shared/components/card-roaming/card-roaming.component';
import {CardTansComponent} from '@app/shared/components/card-tans/card-tans.component';
import {CardUnlockrequestsComponent} from '@app/shared/components/card-unlockrequests/card-unlockrequests.component';
import {CardContentlookupComponent} from '@app/shared/components/card-contentlookup/card-contentlookup.component';
import { CardNotificationComponent } from './components/card-notification/card-notification.component';
import { ModalwarntimeComponent } from './modals/modalwarntime/modalwarntime.component';
import { ModaldsgvoComponent } from './modals/modaldsgvo/modaldsgvo.component';
import { CardInfoNotificationComponent } from './components/card-info-notification/card-info-notification/card-info-notification.component';
import { CardManipulationComponent } from './components/card-manipulation/card-manipulation.component';
import { TimeboxComponent } from './components/card-device/timebox/timebox.component';
import { ModalapplistComponent } from './modals/modalapplist/modalapplist.component';
import { ModalerrorinterceptorComponent } from './modals/modalerrorinterceptor/modalerrorinterceptor.component';
import { FooterLinksComponent } from './components/footer-links/footer-links.component';

import { ModaladdentryComponent } from './modals/modaladdentry/modaladdentry.component';
import { TopactivityComponent } from './components/topactivitiy/topactivity.component';
import { BarchartComponent } from './components/barchart/barchart.component';
import { GoogleMapsModule } from '@angular/google-maps';
import {ModalmissingrightComponent} from '@app/shared/modals/modalmissingright/modalmissingright.component';
import {ModalmanualtimesComponent} from '@app/shared/modals/modalmanualtimes/modalmanualtimes.component';
import { ModalprofilesentryComponent } from './modals/modalprofilesentry/modalprofilesentry.component';
import { CardRoamingpieComponent } from './components/card-roamingpie/card-roamingpie.component';
import { ModalsettingsappComponent } from './modals/modalsettingsapp/modalsettingsapp.component';
import { ModalappkeywordsComponent } from './modals/modalappkeywords/modalappkeywords.component';
import { CardExtensionrequestComponent } from './components/card-extensionrequest/card-extensionrequest.component';
import { ChartPieComponent } from './components/chart-pie/chart-pie.component';
import { CardAllowedPlusComponent } from './components/card-allowed-plus/card-allowed-plus.component';
import { ModalspecialappComponent } from './modals/modalspecialapp/modalspecialapp.component';
import { ModalupdatenoticeComponent } from './modals/modalupdatenotice/modalupdatenotice.component';
import { CardDevicewarningComponent } from './components/card-devicewarning/card-devicewarning.component';
import { BatteryiconComponent } from './components/card-device/batteryicon/batteryicon.component';
import { CardFeatureComponent } from './components/card-feature/card-feature.component';
import { CardSoundlimitComponent } from './components/card-soundlimit/card-soundlimit.component';
import { CardTimesComponent } from './components/card-times/card-times.component';
import { CardVerifyloginComponent } from './components/card-verifylogin/card-verifylogin.component';
import { CardSecuritycheckComponent } from './components/card-securitycheck/card-securitycheck.component';

/**
 * This module contains declarations (components, directives) that are used all over the app.
 * Injectables should not be declared in this module.
 */
@NgModule({
  declarations: [
    ModaldevComponent,
    ModalextensionComponent,
    ModalmanualtimesComponent,
    ModalmessageComponent,
    ModalscreenshotComponent,
    ModaluntilComponent,
    ModalscreenshotsetupComponent,
    ModalroamingComponent,
    AppListComponent,
    ModaltanComponent,
    AppListFilterComponent,
    ModalgrouprenameComponent,
    ModaldevicenameComponent,
    ModalselfprotectionComponent,
    ModalchangeloginnoticeComponent,
    ModalfilenameComponent,
    ModalAppDetailsSuggestionComponent,
    ModalmissingrightComponent,
    ActiondropdownComponent,
    CardDeviceComponent,
    CardPasswordComponent,
    CardRoamingComponent,
    CardTansComponent,
    CardUnlockrequestsComponent,
    CardContentlookupComponent,
    CardNotificationComponent,
    ModalwarntimeComponent,
    ModaldsgvoComponent,
    CardInfoNotificationComponent,
    CardManipulationComponent,
    TimeboxComponent,
    ModalapplistComponent,
    ModalerrorinterceptorComponent,
    ModaladdentryComponent,
    TopactivityComponent,
    BarchartComponent,
    FooterLinksComponent,
    ModalprofilesentryComponent,
    CardRoamingpieComponent,
    ModalsettingsappComponent,
    ModalappkeywordsComponent,
    CardExtensionrequestComponent,
    ChartPieComponent,
    CardAllowedPlusComponent,
    ModalspecialappComponent,
    ModalupdatenoticeComponent,
    CardDevicewarningComponent,
    BatteryiconComponent,
    CardFeatureComponent,
    CardSoundlimitComponent,
    CardTimesComponent,
    CardVerifyloginComponent,
    CardSecuritycheckComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    TranslateModule,
    NgSelectModule,
    // Angular CDK
    CdkTableModule,
    // ngx-bootstrap
    BsDropdownModule,
    TooltipModule,
    PaginationModule,
    // Modules from this project
    UiComponentsModule
  ],
  exports: [
    // Export commonly used modules so that other modules only need to import this SharedModule instead of all the other modules
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    GoogleMapsModule,
    TranslateModule,
    NgSelectModule,
    // Angular CDK
    CdkTableModule,
    A11yModule,
    // ngx-bootstrap
    BsDropdownModule,
    TooltipModule,
    PaginationModule,
    ProgressbarModule,
    // Modules from this project
    UiComponentsModule,
    // Components from this module
    AppListComponent,
    ActiondropdownComponent,
    CardDeviceComponent,
    CardPasswordComponent,
    CardRoamingComponent,
    CardTansComponent,
    CardUnlockrequestsComponent,
    CardContentlookupComponent,
    CardNotificationComponent,
    CardInfoNotificationComponent,
    CardManipulationComponent,
    TopactivityComponent,
    BarchartComponent,
    FooterLinksComponent,
    CardRoamingpieComponent,
    CardExtensionrequestComponent,
    ChartPieComponent,
    CardAllowedPlusComponent,
    CardDevicewarningComponent,
    CardFeatureComponent,
    CardSoundlimitComponent,
    CardTimesComponent,
    CardVerifyloginComponent,
    CardSecuritycheckComponent,
    BatteryiconComponent
  ]
})
export class SharedModule {}
